import { IUser, IRole, IGroup } from "../../models";

export interface IUserListState {
    list: IUser[],
    roles: IRole[],
    groups: IGroup[]
}